var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIssueSubject = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 12,
  fill: "#FFFFFF1A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.855 12.538c-1.49-.12-2.639 1.106-2.639 2.504v7.368c0 1.439 1.159 2.527 2.502 2.634 1.771.142 2.969.507 3.828.905.61.283 1.383-.118 1.383-.79V14.436a.813.813 0 0 0-.443-.735 9.23 9.23 0 0 0-.22-.105c-1.062-.492-2.46-.902-4.411-1.058Zm8.6 13.411c-.61.283-1.383-.118-1.383-.79V14.436c0-.31.165-.597.442-.735a9.23 9.23 0 0 1 .22-.105c1.062-.492 2.46-.902 4.411-1.058 1.49-.12 2.639 1.106 2.639 2.504v7.368c0 1.439-1.159 2.527-2.502 2.634-1.771.142-2.969.507-3.828.905Zm3.138 8.294a.857.857 0 0 1-.845-.857v-3.343c0-.469.377-.85.845-.857l1.252-.018a2.547 2.547 0 1 1 0 5.093l-1.252-.018Zm-3.857-5.002a.857.857 0 0 1 .87.857v3.232a.857.857 0 0 1-.87.857l-8.057-.116a.858.858 0 0 1-.461-.142l-2.263-1.5a.857.857 0 0 1 0-1.43l2.263-1.5a.858.858 0 0 1 .461-.142l8.057-.116Z",
  fill: "#FFF"
})));
export default SvgIssueSubject;